<template>
    <div
        :ref="id"
        :class="[
            {
                'active': isActive,
            },
            'club-item'
        ]"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Club',
        data() {
            return {
                isActive: false,
            };
        },
        props: {
            id: {
                required: false,
                type: Number,
            },
        },
        mounted() {
            eventHub.$on('resetCurrent', () => {
                this.isActive = false;
            });

            eventHub.$on('scrollToActive', (elementId) => {
                if (elementId === this.id) {
                    this.$refs[elementId].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start',
                    });
                    this.toggleClub();
                }
            });
        },
        methods: {
            toggleClub() {
                this.isActive = !this.isActive;
            },
        },
    };
</script>
